import { defineMessages, type MessageDescriptor } from 'react-intl';
import lucia from './images/host-lucia.png';
import mateo from './images/host-mateo.png';
import camila from './images/host-camila.png';
import diego from './images/host-diego.png';
import valentina from './images/host-valentina.png';

const msgs = defineMessages({
  luciaName: { id: 'follow_locals_lucia_name', defaultMessage: 'Lucía' },
  luciaCity: { id: 'follow_locals_lucia_city', defaultMessage: 'Madrid' },
  luciaFact: {
    id: 'follow_locals_lucia_fact',
    defaultMessage: 'Makes tortilla without onion and will defend it to the end',
  },
  mateoName: { id: 'follow_locals_mateo_name', defaultMessage: 'Mateo' },
  mateoCity: { id: 'follow_locals_mateo_city', defaultMessage: 'Buenos Aires' },
  mateoFact: {
    id: 'follow_locals_mateo_fact',
    defaultMessage: 'Drinks mate at 7am, every day, no exceptions',
  },
  camilaName: { id: 'follow_locals_camila_name', defaultMessage: 'Camila' },
  camilaCity: { id: 'follow_locals_camila_city', defaultMessage: 'Mexico City' },
  camilaFact: {
    id: 'follow_locals_camila_fact',
    defaultMessage: 'Knows every taco stand in Roma Norte by name',
  },
  diegoName: { id: 'follow_locals_diego_name', defaultMessage: 'Diego' },
  diegoCity: { id: 'follow_locals_diego_city', defaultMessage: 'Seville' },
  diegoFact: {
    id: 'follow_locals_diego_fact',
    defaultMessage: 'Learned flamenco guitar from his grandmother',
  },
  valentinaName: { id: 'follow_locals_valentina_name', defaultMessage: 'Valentina' },
  valentinaCity: { id: 'follow_locals_valentina_city', defaultMessage: 'Medellín' },
  valentinaFact: {
    id: 'follow_locals_valentina_fact',
    defaultMessage: 'Has cycled every hill in the city, twice',
  },
});

export interface LocalSpeaker {
  key: string;
  name: MessageDescriptor;
  city: MessageDescriptor;
  fact: MessageDescriptor;
  photo: string;
  /** Degrees the blob portrait is tilted. The follow chip rotates back so the icon stays upright. */
  tilt: number;
}

export const LOCALS: LocalSpeaker[] = [
  {
    key: 'lucia',
    name: msgs.luciaName,
    city: msgs.luciaCity,
    fact: msgs.luciaFact,
    photo: lucia,
    tilt: -4,
  },
  {
    key: 'mateo',
    name: msgs.mateoName,
    city: msgs.mateoCity,
    fact: msgs.mateoFact,
    photo: mateo,
    tilt: 3,
  },
  {
    key: 'camila',
    name: msgs.camilaName,
    city: msgs.camilaCity,
    fact: msgs.camilaFact,
    photo: camila,
    tilt: -2,
  },
  {
    key: 'diego',
    name: msgs.diegoName,
    city: msgs.diegoCity,
    fact: msgs.diegoFact,
    photo: diego,
    tilt: 4,
  },
  {
    key: 'valentina',
    name: msgs.valentinaName,
    city: msgs.valentinaCity,
    fact: msgs.valentinaFact,
    photo: valentina,
    tilt: -3,
  },
];
